<nav mat-tab-nav-bar lohiPageTitle="KPI Dashboard">
  <a
    mat-tab-link
    [routerLink]="['revenue-performance']"
    routerLinkActive
    #revenuePerformance="routerLinkActive"
    [active]="revenuePerformance.isActive"
  >
    Revenue Performance
  </a>
  <a
    mat-tab-link
    [routerLink]="['driver-performance']"
    routerLinkActive
    #driverPerformance="routerLinkActive"
    [active]="driverPerformance.isActive"
    *lohiFeatureFlag="'driverPerformanceTab'"
  >
    Driver Performance
  </a>
</nav>
<router-outlet></router-outlet>
